export default {
  serverURI: location.hostname === 'localhost' ? 'https://hamv2-dev.apps.exosite.io' : location.origin,
  fixedLayout: true,
  hideLogoOnMobile: false,
  noLoginPaths: [
    '/',
    '/login',
    '/legal',
    '/reset'
  ]
}



// WEBPACK FOOTER //
// ./src/config/index.js